import React from 'react'
import styled from 'styled-components'
import { Grid, Wrapper, P, H } from '@farewill/ui'
import { BREAKPOINT } from '@farewill/ui/tokens'

import BreakpointSwitch from 'components/BreakpointSwitch'

import CallUs from 'views/cremation/components/CallUs'
import MobileComponent from './MobileComponent'
import DesktopComponent from './DesktopComponent'

import data from './data'

const StyledWrapper = styled(Wrapper)`
  overflow: hidden;
`

const SliceChoices = (): React.ReactElement => (
  <StyledWrapper container>
    <Grid>
      <Grid.Item span={12} spanFromM={10} startColumnFromM={2}>
        <H size="L" decorative centeredFromL>
          {data.title}
        </H>
        <P
          maxWidth={784}
          size="L"
          margin={[0, 'auto']}
          marginFromM={[0, 'auto', 'L']}
          centered
        >
          {data.description}
        </P>
      </Grid.Item>
    </Grid>
    <BreakpointSwitch
      breakAt={BREAKPOINT.M}
      aboveComponent={<DesktopComponent />}
      belowComponent={<MobileComponent />}
    />
    <Grid margin={['XL', 0, 0, 0]}>
      <Grid.Item span={12} spanFromM={10} startColumnFromM={2}>
        <CallUs data={data.callUs} />
      </Grid.Item>
    </Grid>
  </StyledWrapper>
)

export default SliceChoices
